module.exports = __webpack_public_path__ + "static/media/sidebar-7.654ff398.jpeg";